import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Container, Image, Navbar } from "react-bootstrap";
import { apiListInstances, apiGetInstance } from "../../api/ApiInstance";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { chgInstancesAutorisees } from "../../redux/ReduxUser";
import ComponentLoader from "../../components/layout/ComponentLoader";
import ComponentError from "../../components/layout/ComponentError";
import { useNavigate } from "react-router-dom";
import logoEasyGouv from "../../assets/images/logoEasyGouvNoir.png";

import { persistStore } from "redux-persist";
import { store } from "../../redux/store";
import ComponentCardInstance from "../../components/public/instance/ComponentCardInstance";
import { apiGetUserByIdColidee, apiSanitizeUser } from "../../api/ApiUser";
import { MdSettings } from "react-icons/md";
import ModalSettings from "../../components/layout/ModalSettings";
import ComponentFooter from "../../components/layout/ComponentFooter";

const PageChoixInstance = () => {
  const { t } = useTranslation();
  const [instances, setInstances] = useState([]);
  const [loader, setLoader] = useState(true);
  const [error, setError] = useState(false);
  const [derniereVisite, setDerniereVisite] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModalSettings, setShowModalSettings] = useState(false);

  /* on vient lire le store pour choper nom et prenom */
  const { ReduxUserNom, ReduxUserPrenom, ReduxUserEmail, ReduxUserIdColidee } = useSelector(
    (state) => state.ReduxUser
  );

  /* requetage pour voir quelle instance de easygouv proposer */
  const listInstances = async () => {
    setError(false);

    const resUser = await apiGetUserByIdColidee(ReduxUserIdColidee);
    if (resUser.data) {
      setDerniereVisite(resUser.data.derniereVisite);
    }

    const res = await apiListInstances(ReduxUserEmail);
    if (res.data) {
      let instancesNonArchivees = res.data.filter((item) => item.archivage === false);

      verifParamsUrl(instancesNonArchivees);
      setInstances(instancesNonArchivees);
      dispatch(chgInstancesAutorisees(instancesNonArchivees));
    } else {
      setError("Impossible de récupérer les instances");
    }
    setLoader(false);
  };

  const verifParamsUrl = async (listeBruteInstances) => {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      const instanceDemandee = urlParams.get("instance");
      let pageDemandee = urlParams.get("page");
      const popupDemandee = urlParams.get("popup");
      if (instanceDemandee && pageDemandee) {
        const instanceAutorisee = listeBruteInstances.filter(
          (item) => item._id === instanceDemandee
        );

        /* debut */
        if (instanceAutorisee.length === 1) {
          if (pageDemandee) {
            const resDemandee = await apiGetInstance(instanceDemandee, ReduxUserEmail);
            dispatch(chgInstance(resDemandee.data));
            if (popupDemandee) pageDemandee = pageDemandee + "?action=" + popupDemandee;
            navigate("/" + pageDemandee);
          } else selectionneInstance(instanceDemandee);
        }
        /* fin */
      }
    }
  };

  /* permet de mettre dans le store l'instance easygouv choisie et de basculer sur la VRAIE page d'accueil du projet choisi */
  const selectionneInstance = async (id) => {
    setLoader(true);
    setError(false);
    const res = await apiGetInstance(id, ReduxUserEmail);
    if (res.data) {
      dispatch(chgInstance(res.data));
      navigate("/home");
    } else {
      setLoader(false);
      setError("Impossible de récupérer les instances");
    }
  };

  const logout = async () => {
    /* on va regarder si le gars a un deviceToken afin de le remettre dans le local storage pour la prochaine connexion de sa part */
    const deviceTokenSauvegarde = localStorage.getItem("deviceToken");
    /* On vide le local storage completement en vue de la déconnexion*/
    localStorage.clear();

    /* on en profite pour virer de la collection User la valeur de notre token pour ne plus recevoir de notif sur cet appareil jusqu'à la prochaine reconnexion et remettre en place un deviceToken ^pour la prochaine connexion  */
    if (deviceTokenSauvegarde) {
      await apiSanitizeUser(ReduxUserIdColidee, {
        deviceToken: deviceTokenSauvegarde,
      });
      localStorage.setItem("deviceToken", deviceTokenSauvegarde);
    }

    navigate("/");
    return false;
  };

  /* on vérifie la liste des instances pour cet user  */
  useEffect(() => {
    /* IMPLEMENTATION REDUX PERSIST Permet de faire un reset / purge / cancel de redux-persist */
    let persistor = persistStore(store);
    persistor.purge();
    /* Fin permet de faire un reset / purge / cancel de redux-persist */
    listInstances();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* <Navbar className="bg-primary p-2 mb-2" expand="lg">
        <Container>
          <Image src={logoEasyGouv} style={{ maxWidth: "150px", maxHeight: "34px" }} />         
        </Container>
      </Navbar> */}
      <div className="text-center mt-2 mb-5 ">
        <Image src={logoEasyGouv} />
        <MdSettings
          onClick={() => setShowModalSettings(true)}
          color={"#666"}
          style={{
            position: "absolute",
            cursor: "pointer",
            right: 10,
            top: 10,
            height: 20,
            width: 20,
          }}
        />
      </div>
      <Container>
        <h1 className="text-center p-1 ">
          {t("public.pageChoixInstance.welcome")} {ReduxUserPrenom} {ReduxUserNom}
        </h1>
        {instances.length === 0 && (
          <div className="text-center">
            Vous n'avez encore aucun accès aux instances easyGOUV.
            <br />
            Merci de demander les droits au responsable de votre société.
            <br />
            <Button onClick={(e) => logout()} className="text-light mt-5" role="button">
              Se déconnecter
            </Button>
          </div>
        )}

        {instances.length > 0 && (
          <>
            <div className="text-center mb-5">{t("public.pageChoixInstance.choixInstance")}</div>
            {loader && <ComponentLoader />}
            <div className="d-flex align-items-stretch flex-wrap justify-content-center">
              {instances.map((instance) => (
                <ComponentCardInstance
                  key={instance._id}
                  instance={instance}
                  selectionneInstance={selectionneInstance}
                  derniereVisite={derniereVisite}
                />
              ))}
            </div>
          </>
        )}
        {error && <ComponentError>{error}</ComponentError>}
        <ModalSettings show={showModalSettings} closeModal={() => setShowModalSettings(false)} />
      </Container>
      {/* <ComponentFooter /> */}
    </>
  );
};

export default PageChoixInstance;
